import React, { useEffect, useState } from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { useParams, useNavigate } from 'react-router-dom';
import { useFinderApi } from './useFinderApi';
//import { getNeedById, cancelReservation } from './api';
import { Drawer } from 'vaul';
import { AlertDialog } from './ui/AlertDialog';
import { formatRelative } from 'date-fns';


const ReservationDetail = () => {
  const {getNeedById, cancelReservation} = useFinderApi();
  const { id } = useParams();
  const [need, setNeed] = useState(null);
  const [selectedReason, setSelectedReason] = useState('');
  const [otherReason, setOtherReason] = useState(''); // New state for other reason
  const [error, setError] = useState(''); 
  const [cancelling, setCancelling] = useState(false); 
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [showDialog, setShowDialog] = useState(false); 
  const navigate = useNavigate();

  const handleReasonChange = (e) => {
    setSelectedReason(e.target.value);
  };

  const handleCancelNeed = async () => {
    if (!selectedReason) {
      setError('Please select a reason for cancellation.');
      return;
    }

    setCancelling(true); // Set cancelling state to true

    try {
      await cancelReservation(need.id, selectedReason , otherReason); // Call the API
      setDrawerOpen(false);
      setShowDialog(true);
    } catch (error) {
      setError(`Failed to cancel reservation: ${error.message}`); // Display error message
    } finally {
      setCancelling(false); // Set cancelling state to false
    }
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    navigate('/'); // Navigate to the main route after closing the dialog
  };

  useEffect(() => {
    getNeedById(id)
      .then((data) => setNeed(data))
      .catch((error) => console.error('Error fetching need:', error));
  }, [id, getNeedById]);

  if (!need) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col h-screen bg-sr-slate-100">
    {/* Sticky Header with Back Button and Title */}
    <div className="sticky top-0 z-10 bg-sr-slate-100 border-b border-gray-200 px-2 py-1 flex items-center justify-center shadow-md" style={{ minHeight: "40px" }}>
      <button
        onClick={() => navigate('/')}
        className="text-blue-600 text-lg absolute left-2"
        style={{ minWidth: "70px" }}
      >
        ← Back
      </button>
      <span className="text-base font-bold text-sr-darkblue">Shelter Ready</span>
    </div>
    {/* Main Content */}
    <div className="flex-grow overflow-auto px-4 sm:px-8 md:px-16 lg:px-32 xl:px-64 pt-4 pb-24">
      <Drawer.Root open={drawerOpen} onOpenChange={setDrawerOpen}>
        <h2 className="text-xl font-bold my-4 text-sr-darkblue">Reservation Details</h2>
        <Card className="mb-4 border rounded-xl shadow-lg">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">{need.reference_identifier}</h2>
          <h3 className='text-gray-700 mb-8'>{need?.reservation?.lookup_descriptor}</h3>
          <div className="mb-4">
            <p className="text-gray-600 mb-2">Shelter: {need?.reservation?.shelter?.name}</p>
            <p className="text-gray-600 mb-2">Space: {need?.reservation?.space_type?.name}</p>
            <p className="text-gray-600 mb-2">Reserved: {formatRelative(new Date(need?.reservation?.created_at), new Date())}</p>
          </div>
          <Drawer.Trigger asChild>
            <Button>Cancel this reservation</Button>
          </Drawer.Trigger>
        </Card>
        <Drawer.Portal>
          <Drawer.Overlay className="fixed inset-0 bg-black/40" />
          <Drawer.Content className="bg-white flex flex-col fixed bottom-0 left-0 right-0 max-h-[96%] rounded-t-[10px]">
            <div className="max-w-md w-full mx-auto flex flex-col overflow-auto p-4 rounded-t-[10px]">
              <div className="mx-auto w-12 h-1.5 flex-shrink-0 rounded-full bg-zinc-300 mb-8" />
              <Drawer.Title className="text-xl font-bold mb-2">
                Cancel Reservation
              </Drawer.Title>
              <p className="text-sm text-gray-700 mb-6">Please select a reason for canceling this reservation:</p>
              {/* Radio Buttons for Cancellation Reasons */}
              <div className="mb-6">
                <div className="mb-4">
                  <input
                    type="radio"
                    id="reason1"
                    name="cancelReason"
                    value="client_changed_mind"
                    onChange={handleReasonChange}
                    className="mr-2"
                  />
                  <label htmlFor="reason1" className="text-sm text-gray-800">
                    Client changed their mind
                  </label>
                </div>
                <div className="mb-4">
                  <input
                    type="radio"
                    id="reason2"
                    name="cancelReason"
                    value="secured_other_shelter"
                    onChange={handleReasonChange}
                    className="mr-2"
                  />
                  <label htmlFor="reason2" className="text-sm text-gray-800">
                    Client secured other shelter/housing
                  </label>
                </div>
                <div className="mb-4">
                  <input
                    type="radio"
                    id="reason3"
                    name="cancelReason"
                    value="transportation_unavailable"
                    onChange={handleReasonChange}
                    className="mr-2"
                  />
                  <label htmlFor="reason3" className="text-sm text-gray-800">
                    Transportation not available
                  </label>
                </div>
                <div className="mb-4">
                  <input
                    type="radio"
                    id="reason4"
                    name="cancelReason"
                    value="lost_contact"
                    onChange={handleReasonChange}
                    className="mr-2"
                  />
                  <label htmlFor="reason4" className="text-sm text-gray-800">
                    Lost contact or unable to locate client
                  </label>
                </div>
                <div className="mb-4">
                  <input
                    type="radio"
                    id="reason5"
                    name="cancelReason"
                    value="referral_error"
                    onChange={handleReasonChange}
                    className="mr-2"
                  />
                  <label htmlFor="reason5" className="text-sm text-gray-800">
                    Referral/reservation made in error
                  </label>
                </div>
                <div className="mb-4">
                  <input
                    type="radio"
                    id="reason6"
                    name="cancelReason"
                    value="other"
                    onChange={handleReasonChange}
                    className="mr-2"
                  />
                  <label htmlFor="reason6" className="text-sm text-gray-800">
                    Other
                  </label>
                  {selectedReason === "other" && (
                    <input
                      type="text"
                      className="mt-2 block w-full border border-gray-300 rounded p-2 text-sm"
                      placeholder="Please specify the reason"
                      value={otherReason || ''}
                      onChange={e => setOtherReason(e.target.value)}
                      maxLength={200}
                    />
                  )}
                </div>
                {error && <p className="text-red-600 text-sm mt-2">{error}</p>}
              </div>
              {/* Buttons */}
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setDrawerOpen(false)} // <-- Change here
                  className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                >
                  Don't Cancel
                </button>
                <button
                  onClick={handleCancelNeed}
                  className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                  disabled={cancelling}
                >
                  {cancelling ? 'Cancelling...' : 'Cancel Reservation'}
                </button>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
        <AlertDialog
          isOpen={showDialog}
          title="Cancellation Confirmed"
          message="This reservation has been canceled."
          onClose={handleCloseDialog}
        />
      </Drawer.Root>
    </div>
  </div>
  );
};

export default ReservationDetail;